export default __webpack_public_path__ + "1.17.16/static/media/LibreDataShare_Japanese.504fe043.svg";